export default __webpack_public_path__ + "static/media/hm-evo-img.3853484a.webp";